import { useState } from "react";
import styles from "../ForgotPassword.module.scss";

import { InputPassword } from "../../../components/ui/InputPassword/InputPassword";
import { Button } from "../../../components";
import { AuthContainer } from "../../../components/AuthContainer/AuthContainer";
import { ROUTES } from "../../../helpers/routes";

export const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [passwordDuplicate, setPasswordDuplicate] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <AuthContainer
      title="Set a password"
      subtitle="Your previous password has been reseted. Please set a new password for your account."
    >
      <form action="POST" className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.form__password}>
          <InputPassword
            value={password}
            setValue={setPassword}
            id="password"
            label="Create Password"
            required
            autoComplete="new-password"
            placeholder="Enter the password"
            minLength={8}
          />

          <InputPassword
            value={passwordDuplicate}
            setValue={setPasswordDuplicate}
            id="password-duplicate"
            label="Re-enter Password"
            required
            autoComplete="new-password"
            placeholder="Enter the password"
            minLength={8}
          />
        </div>
        <Button type="submit" disabled={password !== passwordDuplicate}>
          Set password
        </Button>
      </form>
    </AuthContainer>
  );
};
